import SignUpForm from "#/src/features/SignUpForm/SignUpForm";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { JWT } from "~/apollo/_config";

type Props = {};

const SignUp = (props: Props) => {
  const navigate = useNavigate();
  const authToken = localStorage.getItem(JWT.LOCAL_STORAGE.TOKEN.NAME);

  useEffect(() => {
    if (authToken) {
      navigate("/app");
    }
  }, []);
  return (
    <div className="w-screen h-screen flex justify-center items-center">
      <SignUpForm />
    </div>
  );
};

export default SignUp;
